const { action } = require("../utils/requests")

export const sendEmail = (to, subject, template, context) => action('send_email', { to, subject, template, context });

